import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';

import { SearchDialogComponent } from './search-dialog.component';
import { SearchDialogPageComponent } from './search-dialog-page.component';

@NgModule({
    imports: [SharedPageModule],
    declarations: [SearchDialogComponent, SearchDialogPageComponent],
    providers: [
        //DataService  -- setup provider in descendant
    ],
    exports: [SearchDialogComponent, SearchDialogPageComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SearchDialogModule { }
